import React from "react";
//import { withRouter } from "react-router-dom";
import Constants from "./../../Utils/Constants";
import vybrntwhite from "./vybrnt-sms-logo.svg";

import "./index.scoped.css";

function HomeLogo(props) {
  return (
    <div
      className="brand-name"
      onClick={() => {
        props.history.push(Constants.home);
      }}
    >
      <img className="white-logo" src={vybrntwhite} />
      {props?.data?.logo && <img className="white-logo partner-logo" src={props?.data?.logo} />}
    </div>
  );
}

// export default withRouter(HomeLogo);
export default HomeLogo;
